// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__12Hvy","col":"styles_col__1ZJOn"};